import { useTranslation } from 'react-i18next';
import { doctors } from '../../../mocks/doctors';

const DoctorsSection = () => {
  const { t, i18n } = useTranslation();

  const getName = (doctor: typeof doctors[0]) => {
    if (i18n.language === 'ro') return doctor.nameRo;
    if (i18n.language === 'en') return doctor.nameEn;
    return doctor.name;
  };

  const getSpecialization = (doctor: typeof doctors[0]) => {
    if (i18n.language === 'ro') return doctor.specializationRo;
    if (i18n.language === 'en') return doctor.specializationEn;
    return doctor.specialization;
  };

  return (
    <section id="doctors" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t('doctors.title')}
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            {t('doctors.subtitle')}
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8">
          {doctors.map((doctor) => (
            <div 
              key={doctor.id}
              className="group relative bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]"
            >
              <div className="relative h-96 overflow-hidden">
                <img 
                  src={doctor.image}
                  alt={getName(doctor)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/95 via-gray-900/40 to-transparent"></div>
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-xl font-semibold mb-2">
                  {getName(doctor)}
                </h3>
                <p className="text-sm text-teal-300 mb-3 font-medium">
                  {getSpecialization(doctor)}
                </p>
                <div className="flex items-center text-sm text-gray-300">
                  <i className="ri-award-line mr-2 text-teal-400"></i>
                  <span>{t('doctors.experience')}: {doctor.experience} {t('doctors.years')}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DoctorsSection;